import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { options } from "../../../Utils/constants";
import BigIMG from "../Assets/login-render3.webp";
import { useEffect } from "react";

const Login = () => {
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);
    const formData = Object.fromEntries(data.entries());

    const response = await axios
      .post(`${process.env.REACT_APP_EDAIN_URL}/api/auth/signin`, formData)
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 422:
              toast.error("You must enter a valid email address", {
                toastId: "validEmail",
                hideProgressBar: true
              });
              break;
            case 401:
              toast.error("Invalid username or password!", {
                toastId: "401_error",
                hideProgressBar: true
              });
              break;
            case 429:
              toast.error(
                "This account is already a member of ZiXXar, you will be shortly redirected",
                {
                  toastId: "429",
                  hideProgressBar: true
                }
              );
              setTimeout(() => {
                window.location.replace("https://shop.zixxar.net/");
              }, 4000);
              break;
            case 403:
              toast.error("Please confirm your email before logging in", {
                toastId: "not_confirmed",
                hideProgressBar: true,
                style: options.dropdownStyle
              });
              break;
            case 430:
              navigate("/already-assigned");
              break;
          }
        }
      });

    if (response?.status === 200) {
      localStorage.setItem("jwt", response.data.token);
      toast.success("Successfully connected!");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
  };

  // useEffect(() => {
  //   window.location.replace("https://shop.zixxar.net/");
  // }, []);

  return (
    <div className="login d-flex flex-column flex-lg-row align-items-center">
      <div className="left  w-100 h-100 d-flex align-items-center justify-content-center">
        <div className="w-100 d-flex align-items-center justify-content-center gap-3 flex-column">
          <img src={BigIMG} alt="incentive img" className="img-fluid  d-none d-lg-block" />
        </div>
      </div>
      <div className="right px-3 w-100 h-100 d-flex align-items-center justify-content-center">
        <div className="right-inner">
          <h2 className="font-pnsb text-light text-center text-lg-start">Sign in</h2>
          <p className="font-pnsb fw-normal font-size-24 text-light  text-center text-lg-start ">
            Discover many new and amazing opportunities!
          </p>
          <form onSubmit={handleSubmit} className="form-sign mt-5" autoComplete="off">
            <input type="hidden" name="domain" value="bazaar" />
            <fieldset className="mb-4">
              <label htmlFor="email">Email</label>
              <input autoComplete="chrome-off" type="text" id="email" name="email" />
            </fieldset>
            <fieldset className="mb-4">
              <label htmlFor="password">Password</label>
              <input autoComplete="chrome-off" type="password" id="password" name="password" />
            </fieldset>
            <div className="text-end mb-4">
              <a
                className="general-a-join text-light"
                target="_blank"
                rel="noreferrer"
                href="https://shop.zixxar.net/forgot-password/send-email">
                Forgot password?
              </a>
            </div>
            <button>
              <span>Sign in</span>
            </button>
          </form>
          <p className="mb-0 mt-4 text-center font-pnsb font-size-20 text-light fw-normal">
            Don't have an account?{" "}
            <Link to="/register" className="general-a-join neon-a-join">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Login;
